import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"  viewBox="0 0 1080.000000 809.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,809.000000) scale(0.100000,-0.100000)">
<path d="M1596 5195 c-702 -133 -1126 -843 -905 -1517 127 -391 459 -691 862
-779 386 -85 784 31 1070 310 230 224 350 511 350 836 -1 539 -356 993 -883
1132 -122 32 -370 41 -494 18z m479 -114 c399 -110 690 -417 782 -824 25 -111
22 -337 -5 -450 -49 -201 -131 -352 -271 -499 -87 -92 -253 -219 -268 -205
-14 15 -35 134 -43 247 -5 69 -16 161 -24 205 -9 44 -16 94 -16 111 0 17 -7
49 -17 70 -22 53 -82 247 -94 309 -6 28 -17 60 -25 72 -11 18 -14 69 -14 240
0 193 -3 223 -19 260 -11 24 -32 48 -48 56 -15 8 -111 41 -213 72 l-185 58
-34 -19 c-19 -11 -44 -32 -55 -47 -20 -27 -21 -43 -24 -288 l-3 -259 -24 16
c-23 15 -27 15 -51 -1 -30 -20 -27 -46 12 -104 13 -19 24 -40 24 -44 0 -15 40
-60 63 -71 34 -18 36 -80 3 -111 -14 -13 -26 -28 -26 -34 0 -5 -9 -12 -19 -16
-33 -10 -14 -35 21 -28 35 7 48 -7 48 -54 0 -25 -10 -40 -52 -78 -47 -42 -50
-47 -35 -62 13 -14 21 -14 42 -5 31 14 51 7 59 -20 7 -28 -9 -56 -58 -100
l-41 -36 23 -24 c18 -20 22 -36 22 -89 0 -42 5 -72 16 -87 18 -26 84 -62 115
-62 11 0 47 -21 80 -47 32 -27 79 -64 105 -83 25 -19 58 -45 73 -58 l26 -23
-145 4 c-179 6 -299 35 -445 106 -284 139 -490 391 -572 699 -22 83 -26 119
-27 252 0 94 4 179 12 215 94 432 409 753 832 846 121 27 380 21 495 -10z
m-429 -340 c16 -6 102 -33 192 -61 159 -50 164 -52 178 -85 21 -51 21 -1292 0
-1321 -14 -18 -26 -19 -203 -16 -170 3 -190 5 -208 23 -20 19 -20 35 -23 728
-2 637 -1 711 14 725 18 19 14 18 50 7z"/>
<path d="M1473 3959 c-58 -29 -70 -62 -51 -142 14 -57 13 -64 -3 -87 -25 -36
-33 -130 -13 -158 8 -12 15 -32 14 -45 -7 -80 0 -106 40 -152 38 -44 40 -45
40 -20 0 15 -11 40 -25 57 -25 29 -32 48 -17 48 4 0 26 17 50 39 61 56 56 115
-7 81 -24 -12 -57 11 -63 45 -4 19 -1 25 11 25 23 0 91 71 91 95 0 37 -16 50
-44 37 -24 -10 -27 -9 -41 18 -13 26 -14 30 -1 30 25 0 86 72 86 101 0 43 -20
51 -67 28z"/>
<path d="M3250 4366 l0 -436 90 0 90 0 0 154 0 154 148 5 c165 5 203 14 264
60 125 95 139 305 28 415 -18 18 -51 43 -74 55 -39 21 -55 22 -293 25 l-253 4
0 -436z m445 258 c34 -16 65 -65 65 -104 0 -31 -25 -75 -54 -94 -20 -13 -51
-16 -151 -16 l-125 0 0 115 0 115 116 0 c85 0 125 -4 149 -16z"/>
<path d="M4750 4365 l0 -435 80 0 80 0 0 435 0 435 -80 0 -80 0 0 -435z"/>
<path d="M6450 4793 c-1 -5 54 -200 122 -435 l122 -428 97 0 97 0 20 78 c12
42 44 172 73 287 28 116 55 213 58 217 3 4 40 -125 81 -287 l75 -295 97 0 97
0 20 68 c11 37 65 225 120 417 55 193 103 358 107 368 6 15 -4 17 -99 17 -100
0 -105 -1 -111 -22 -3 -13 -36 -147 -72 -298 -36 -151 -69 -278 -73 -282 -4
-4 -42 130 -86 297 l-80 305 -72 0 -72 0 -15 -52 c-8 -29 -45 -168 -82 -308
-36 -140 -68 -256 -69 -258 -2 -2 -35 131 -75 295 -39 164 -73 304 -76 311 -4
13 -204 18 -204 5z"/>
<path d="M8380 4365 l0 -435 80 0 80 0 0 435 0 435 -80 0 -80 0 0 -435z"/>
<path d="M8710 4365 l0 -435 80 0 80 0 0 435 0 435 -80 0 -80 0 0 -435z"/>
<path d="M9800 4650 l0 -90 -55 0 -55 0 0 -70 0 -70 55 0 55 0 0 -190 c0 -214
8 -248 69 -283 41 -24 125 -32 176 -18 70 19 71 22 54 88 l-15 58 -49 0 c-69
0 -75 14 -75 198 l0 147 65 0 65 0 0 70 0 70 -65 0 -65 0 0 90 0 90 -80 0 -80
0 0 -90z"/>
<path d="M4231 4569 c-63 -11 -163 -53 -186 -79 -16 -17 -15 -22 11 -67 15
-26 29 -50 31 -52 1 -2 11 3 21 12 53 48 165 71 229 46 56 -21 73 -47 73 -111
l0 -58 -37 24 c-80 53 -209 57 -291 10 -96 -56 -119 -206 -45 -294 43 -51 98
-74 179 -75 60 0 80 5 132 32 l62 32 0 -30 0 -29 86 0 86 0 -4 243 -3 242 -28
47 c-35 59 -91 93 -177 107 -36 6 -69 10 -75 10 -5 -1 -34 -5 -64 -10z m110
-360 c54 -18 69 -37 69 -84 0 -48 -16 -66 -73 -85 -87 -28 -177 15 -177 85 0
73 89 114 181 84z"/>
<path d="M5382 4565 c-29 -8 -73 -29 -98 -45 l-44 -31 0 36 0 35 -85 0 -85 0
0 -315 0 -315 85 0 85 0 0 215 0 214 28 26 c63 59 153 57 184 -5 15 -30 18
-65 18 -242 l0 -208 80 0 80 0 0 213 0 213 28 26 c54 53 124 62 169 24 l28
-24 3 -226 3 -226 80 0 79 0 0 263 c0 253 -1 263 -23 302 -57 102 -239 105
-342 5 l-30 -29 -28 34 c-51 64 -125 84 -215 60z"/>
<path d="M7862 4569 c-55 -9 -141 -46 -179 -76 l-22 -18 32 -52 32 -51 26 19
c64 46 168 62 233 35 48 -20 66 -51 66 -114 l0 -53 -27 19 c-52 35 -97 47
-173 46 -78 0 -136 -21 -172 -61 -43 -47 -61 -147 -37 -210 27 -72 125 -133
214 -133 49 0 131 28 165 56 l30 26 0 -36 0 -36 80 0 80 0 0 239 c0 270 -3
287 -70 343 -62 54 -171 76 -278 57z m151 -377 c29 -16 32 -23 32 -67 0 -44
-3 -51 -32 -67 -76 -45 -182 -27 -212 36 -12 25 -11 33 3 63 9 20 30 40 49 49
40 18 117 12 160 -14z"/>
<path d="M9269 4570 c-103 -18 -198 -92 -241 -188 -16 -35 -22 -68 -22 -132
-1 -77 2 -92 32 -152 67 -136 211 -199 381 -168 70 13 159 52 167 75 3 8 -8
34 -26 59 l-31 46 -48 -25 c-26 -14 -71 -28 -100 -32 -91 -11 -183 43 -197
115 l-6 32 232 0 233 0 -5 74 c-13 198 -176 330 -369 296z m148 -150 c32 -19
63 -66 63 -95 0 -13 -22 -15 -156 -15 l-155 0 6 23 c12 37 35 67 68 87 43 27
131 27 174 0z"/>
<path d="M4970 3765 l0 -55 2575 0 2575 0 0 55 0 55 -2575 0 -2575 0 0 -55z"/>
<path d="M3290 3400 l0 -180 25 0 c24 0 25 2 25 75 l0 75 35 0 c33 0 39 -5 83
-75 40 -64 51 -75 75 -75 l27 0 -26 43 c-15 23 -36 55 -47 71 -15 21 -17 31
-9 34 7 2 26 15 42 29 35 29 48 81 30 123 -21 50 -48 60 -160 60 l-100 0 0
-180z m204 118 c22 -31 20 -64 -4 -88 -16 -16 -33 -20 -85 -20 l-65 0 0 65 0
65 69 0 c61 0 72 -3 85 -22z"/>
<path d="M4240 3565 c-15 -18 -6 -45 13 -45 8 0 20 7 27 15 10 12 10 18 0 30
-16 19 -24 19 -40 0z"/>
<path d="M6420 3400 l0 -180 25 0 c25 0 25 1 25 85 l0 85 95 0 c88 0 95 1 95
20 0 19 -7 20 -95 20 l-95 0 0 55 0 54 97 3 c84 3 98 6 101 21 3 15 -8 17
-122 17 l-126 0 0 -180z"/>
<path d="M7530 3515 l0 -65 -32 20 c-42 25 -74 25 -116 0 -42 -26 -66 -80 -59
-138 6 -57 34 -93 84 -111 37 -13 44 -13 82 6 31 16 41 17 41 7 0 -8 9 -14 20
-14 19 0 20 7 20 180 0 173 -1 180 -20 180 -18 0 -20 -7 -20 -65z m-30 -80
c29 -15 30 -18 30 -85 0 -67 -1 -70 -30 -85 -42 -22 -77 -19 -105 10 -20 19
-25 34 -25 75 0 85 58 122 130 85z"/>
<path d="M8810 3400 l0 -180 106 0 c103 0 106 1 135 29 40 40 40 91 0 131
l-28 29 23 22 c35 33 34 100 -2 128 -23 18 -41 21 -130 21 l-104 0 0 -180z
m207 114 c15 -24 15 -29 2 -53 -14 -24 -20 -26 -92 -29 l-77 -3 0 56 0 55 75
0 c69 0 76 -2 92 -26z m-1 -149 c19 -25 18 -64 -3 -87 -13 -14 -31 -18 -90
-18 l-73 0 0 66 0 66 76 -4 c60 -3 79 -7 90 -23z"/>
<path d="M9870 3400 l0 -180 25 0 25 0 0 180 0 180 -25 0 -25 0 0 -180z"/>
<path d="M4630 3520 c0 -33 -3 -40 -20 -40 -11 0 -20 -7 -20 -15 0 -8 9 -15
20 -15 19 0 20 -7 20 -100 0 -88 2 -102 21 -121 16 -16 28 -20 52 -15 37 8 41
11 34 30 -4 9 -14 12 -27 9 -32 -9 -40 12 -40 110 l0 87 30 0 c20 0 30 5 30
15 0 10 -10 15 -30 15 -28 0 -30 2 -30 40 0 33 -3 40 -20 40 -17 0 -20 -7 -20
-40z"/>
<path d="M10010 3520 c0 -36 -2 -40 -25 -40 -16 0 -25 -6 -25 -15 0 -9 9 -15
25 -15 24 0 24 -1 27 -107 3 -104 4 -108 30 -122 21 -12 31 -13 52 -3 32 14
25 38 -12 37 l-27 0 -3 98 -3 97 31 0 c20 0 30 5 30 15 0 10 -10 15 -30 15
-28 0 -30 2 -30 40 0 33 -3 40 -20 40 -17 0 -20 -7 -20 -40z"/>
<path d="M3673 3475 c-51 -22 -75 -69 -70 -137 4 -68 29 -102 88 -119 65 -20
162 15 140 50 -7 11 -13 11 -32 -3 -38 -27 -96 -21 -130 13 -53 54 -43 61 82
61 l111 0 -7 36 c-9 51 -33 84 -72 100 -41 17 -69 17 -110 -1z m114 -47 c46
-52 41 -58 -57 -58 -50 0 -90 2 -90 5 0 14 31 64 42 68 34 14 85 6 105 -15z"/>
<path d="M3974 3474 c-16 -8 -38 -28 -47 -43 -21 -36 -22 -113 -1 -156 30 -64
121 -82 172 -34 l22 20 0 -29 c0 -16 -9 -41 -21 -56 -17 -21 -29 -26 -68 -26
-25 0 -56 7 -68 15 -18 13 -22 13 -33 0 -9 -11 -6 -17 15 -31 39 -25 113 -29
155 -7 53 28 60 50 60 211 0 135 -1 142 -20 142 -14 0 -20 -7 -20 -21 0 -19
-1 -19 -17 -4 -35 36 -81 43 -129 19z m120 -45 c23 -18 26 -28 26 -79 0 -51
-3 -61 -26 -79 -35 -28 -77 -26 -111 3 -24 21 -28 32 -28 76 0 44 4 55 28 76
34 29 76 31 111 3z"/>
<path d="M4394 3476 c-33 -15 -44 -33 -44 -71 0 -31 21 -46 94 -70 63 -21 80
-42 56 -70 -16 -19 -73 -19 -109 0 -25 12 -31 12 -41 0 -18 -22 32 -49 94 -49
73 -1 106 22 106 74 0 46 -18 61 -99 86 -55 16 -71 35 -51 59 16 19 79 19 107
0 18 -13 22 -13 33 0 28 34 -88 67 -146 41z"/>
<path d="M4845 3474 c-98 -49 -99 -200 -1 -245 23 -10 51 -19 63 -19 33 0 103
30 103 44 0 22 -12 25 -41 11 -44 -23 -96 -19 -124 10 -14 13 -25 33 -25 45 0
19 6 20 105 20 l105 0 0 28 c0 40 -36 91 -75 108 -44 18 -72 18 -110 -2z m120
-49 c47 -46 35 -55 -65 -55 l-91 0 12 23 c23 44 41 57 81 57 28 0 46 -7 63
-25z"/>
<path d="M5173 3470 c-27 -16 -33 -17 -33 -5 0 8 -9 15 -20 15 -19 0 -20 -7
-20 -130 0 -123 1 -130 20 -130 19 0 20 7 20 93 0 102 8 119 63 132 17 5 27
14 27 26 0 24 -17 24 -57 -1z"/>
<path d="M7112 3470 c-39 -24 -42 -24 -42 -5 0 8 -9 15 -20 15 -19 0 -20 -7
-20 -130 0 -123 1 -130 20 -130 19 0 20 7 20 94 0 90 1 96 26 115 29 23 64 27
95 11 17 -10 19 -22 19 -115 l0 -105 25 0 c25 0 25 0 25 94 0 108 -11 149 -46
165 -36 16 -65 14 -102 -9z"/>
<path d="M4240 3350 c0 -123 1 -130 20 -130 19 0 20 7 20 130 0 123 -1 130
-20 130 -19 0 -20 -7 -20 -130z"/>
<path d="M6730 3372 c0 -123 10 -147 65 -158 25 -4 46 -1 75 14 31 15 40 16
40 6 0 -8 9 -14 20 -14 19 0 20 7 20 130 0 123 -1 130 -20 130 -19 0 -20 -7
-20 -100 l0 -99 -30 -16 c-39 -20 -73 -19 -93 3 -13 15 -17 39 -17 115 0 90
-1 97 -20 97 -19 0 -20 -7 -20 -108z"/>
<path d="M9150 3372 c0 -123 10 -147 65 -158 25 -4 46 -1 75 14 31 15 40 16
40 6 0 -8 9 -14 20 -14 19 0 20 7 20 130 0 123 -1 130 -20 130 -19 0 -20 -7
-20 -100 l0 -99 -30 -16 c-80 -42 -110 -9 -110 122 0 86 -1 93 -20 93 -19 0
-20 -7 -20 -108z"/>
<path d="M9420 3478 c0 -2 25 -61 54 -133 55 -130 55 -130 37 -160 -9 -16 -26
-32 -37 -34 -18 -3 -34 -18 -34 -33 0 -17 60 -7 84 15 19 17 156 317 156 342
0 4 -10 5 -22 3 -18 -2 -30 -23 -62 -100 -22 -54 -43 -98 -46 -98 -3 0 -23 45
-45 100 -34 86 -43 100 -62 100 -13 0 -23 -1 -23 -2z"/>
<path d="M5700 3340 l0 -70 70 0 70 0 0 70 0 70 -70 0 -70 0 0 -70z"/>
<path d="M8120 3340 l0 -70 70 0 70 0 0 70 0 70 -70 0 -70 0 0 -70z"/>

</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
